module.exports = __webpack_public_path__ + "images/mstile-310x150-cd0cb24bc3c3910d9c76db46919b134d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/mstile-310x150.png
// module id = ./src/images/favicons/mstile-310x150.png
// module chunks = 1